import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-white font-semibold mb-4">Legal</h3>
            <ul className="space-y-2">
              <li>
                <a href="/terms" className="text-gray-300 hover:text-white text-sm">
                  Terms of Service
                </a>
              </li>
              <li>
                <a href="/privacy-policy" className="text-gray-300 hover:text-white text-sm">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="/dmca" className="text-gray-300 hover:text-white text-sm">
                  DMCA
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="text-white font-semibold mb-4">Resources</h3>
            <ul className="space-y-2">
              <li>
                <a href="/media-kit.html" className="text-gray-300 hover:text-white text-sm">
                  Media Kit
                </a>
              </li>
              <li>
                <a href="/api-docs" className="text-gray-300 hover:text-white text-sm">
                  API Documentation
                </a>
              </li>
              <li>
                <a href="/pricing" className="text-gray-300 hover:text-white text-sm">
                  Pricing
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="text-white font-semibold mb-4">Contact</h3>
            <ul className="space-y-2">
              <li>
                <a href="mailto:press@remuvr.com" className="text-gray-300 hover:text-white text-sm">
                  Press Inquiries
                </a>
              </li>
              <li>
                <a href="mailto:support@remuvr.com" className="text-gray-300 hover:text-white text-sm">
                  Support
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-8 pt-8 border-t border-gray-800">
          <p className="text-center text-gray-400 text-sm">
            &copy; {new Date().getFullYear()} Remuvr. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
